import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import {
  genTemplateBodyAction,
  genTemplateBodyDate,
  genTemplateBodyText,
} from "../../../../../components/utils/TableTemplateBodyGenerator";
import { confirmDialog } from "primereact/confirmdialog";
import { Button } from "primereact/button";
import { useLocation, useNavigate } from "react-router-dom";
import { format } from "date-fns";
import { Paginator } from "primereact/paginator";
import { forwardRef, useEffect, useImperativeHandle } from "react";
import { useAPIGetSedangProses } from "../api/api-get-del-sedang-proses";
import extractUrlParams from "../api/extract-url-params";
import useIsMobile from "../../../../../hooks/useIsMobile";


const ListSedangProses = forwardRef((props, ref) => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const location = useLocation();

  const { filterValue, onLoadingChange } = props;

  const {
    loading,
    paging,
    fetchListSedangProses,
    deleteData,
    listDataSedangProses,
    handleOnPage,
  } = useAPIGetSedangProses({ filterValue });

  useImperativeHandle(ref, () => ({
    reload: () => {
      fetchListSedangProses({ filterValue });
    },
  }));

  // useEffect section

  useEffect(() => {
    firstFetch();
  }, []);

  useEffect(() => {
    if (onLoadingChange) {
      onLoadingChange(loading);
    }
  }, [loading, onLoadingChange]);

  // other function section

  const firstFetch = async () => {
    const { page, take, filter, filterValue } = await extractUrlParams(
      location
    );
    if (filterValue) {
      fetchListSedangProses({ filterValue });
    }
  };

  // handle ui event section

  const handleOnClickDeleteRow = async (row) => {
    confirmDialog({
      message: "Menghapus form pemakaian mobil, lanjutkan?",
      header: "Konfirmasi Hapus",
      icon: "pi pi-exclamation-triangle",
      acceptClassName: "p-button-danger",
      accept: () => {
        deleteData({ id: row.id });
      },
    });
  };

  const handleOnClickEdit = (row) => {
    const urlParams = new URLSearchParams(location.search);
    const key = urlParams.get("key");
    let url = `/audit/audit-kendaraan/edit/${row.id}`;
    if (key) url += `?key=${encodeURIComponent(key)}`;

    if (isMobile) navigate(url);
    else window.open(url, "_blank");
  };

  // custom ui section

  const tanggalBodyTemplate = (row) =>
    genTemplateBodyDate({
      row,
      field: "tanggal",
      format: "dd/MM/yyyy HH:mm",
    });

  const kendaraanBodyTemplate = (row) =>
    genTemplateBodyText({ row, field: "data_kendaraan.nomor_polisi" });
  const jenisMobilBodyTemplate = (row) =>
    genTemplateBodyText({ row, field: "data_kendaraan.jenis_mobil" });

  const actionBodyTemplate = (row) => {
    return (
      <div className="row-start-center gap-2">
        <Button
          icon="pi pi-pencil"
          rounded
          severity="primary"
          className="bg-indigo-400 max-w-[1.85rem] max-h-[1.85rem]"
          onClick={() => handleOnClickEdit(row)}
        />
        <Button
          icon="pi pi-trash"
          rounded
          severity="danger"
          className="bg-red-400 border-red-400 max-w-[1.85rem] max-h-[1.85rem]"
          onClick={() => handleOnClickDeleteRow(row)}
        />
      </div>
    );
  };


  const deskripsiSmallSizeBodyTemplate = (row) => {
    const {
      data_kendaraan,
      tanggal,
      no,
    } = row;

    return (
      <div className="col-start-start py-2">
        <div className="row-start-center gap-2 w-full">
          <span className="text-slate-400 text-sm font-semibold"># {no}, </span>
          <span className="text-slate-400 text-sm font-semibold italic">
            {format(new Date(tanggal), "dd/MM/yyyy HH:mm")}
          </span>
        </div>

        <div className="row-start-center gap-2 pt-3">
          <span>{data_kendaraan?.jenis_mobil},</span>
          <span>{data_kendaraan?.nomor_polisi}</span>
        </div>

        <div className="row-around-start w-full pt-4 ">
          <div className="row-start-start w-full  gap-4">
            <div className="row-start-center gap-1">
              <Button
                icon="pi pi-pencil"
                rounded
                severity="success"
                className="bg-emerald-400 max-w-[1.85rem] max-h-[1.85rem]"
                pt={{ icon: { className: "!text-xs" } }}
                onClick={() => handleOnClickEdit(row)}
              />
            </div>
          </div>
          <Button
            icon="pi pi-trash"
            rounded
            severity="danger"
            className="bg-red-400 border-red-400 max-w-[1.85rem] max-h-[1.85rem]"
            onClick={() => handleOnClickDeleteRow(row)}
            pt={{ icon: { className: "!text-xs" } }}
          />
        </div>
      </div>
    );
  };

  return (
    <div className={`elevated-card row-start-start w-100  wrap gap-4`}>
      <span className="text-sm font-semibold text-zinc-700">
        SEDANG DI PROSES
      </span>

      <div className={`col-center-center gap-2 w-100`}>
        {!isMobile && (
          <>
            <DataTable
              dataKey="id"
              className="w-100"
              loading={loading}
              showGridlines
              stripedRows
              editMode="cell"
              value={listDataSedangProses}
            >
              <Column
                field="no"
                header="#"
                headerClassName="w-[4rem]"
                className="text-right"
                alignHeader={"right"}
              />
              <Column header="Action" headerClassName="w-[4rem]" alignHeader={"center"} body={actionBodyTemplate} />
              <Column header="Tanggal" body={tanggalBodyTemplate} />
              <Column header="Kendaraan" body={kendaraanBodyTemplate} />
              <Column header="Jenis Mobil" body={jenisMobilBodyTemplate} />
            </DataTable>
            <Paginator
              first={parseInt(paging?.take) * (paging?.page - 1)}
              rows={parseInt(paging?.take)}
              totalRecords={parseInt(paging?.total)}
              rowsPerPageOptions={[5, 10, 20, 50]}
              onPageChange={handleOnPage}
            />
          </>
        )}

        {isMobile && (
          <>
            <DataTable
              dataKey="id"
              className="w-100"
              loading={loading}
              showGridlines
              stripedRows
              editMode="cell"
              value={listDataSedangProses}
            >
              <Column
                header="Deskripsi"
                align={"center"}
                body={deskripsiSmallSizeBodyTemplate}
              />
            </DataTable>
            <Paginator
              first={parseInt(paging.take) * (paging.page - 1)}
              rows={parseInt(paging.take)}
              totalRecords={parseInt(paging.total)}
              rowsPerPageOptions={[5, 10, 20, 50]}
              template={{
                layout: "PrevPageLink CurrentPageReport NextPageLink RowsPerPageDropdown",
              }}
              onPageChange={handleOnPage}
              pt={{
                prevPageButton: {
                  className:
                    "bg-white-100 !m-0 !max-w-[22px] !w-[22px] !min-w-[22px] max-h-[22px]",
                },
                nextPageButton: {
                  className:
                    "bg-white-100 !m-0 !max-w-[22px] !w-[22px] !min-w-[22px] max-h-[22px]",
                },
                current: {
                  className: "bg-white-100 !m-0 max-h-[22px] text-sm",
                },
                rowsPerPageDropdown: {
                  className: "bg-white-100 !m-0 max-h-[22px]",
                },
              }}
            />
          </>
        )}


      </div>
    </div>
  );
});

export default ListSedangProses;
